import ScreenStatusMapMdl from '../uc/screenStatusMap/ScreenStatusMapMdl';

const DoohMapReducer = {
    screenStatusMapMdl: ScreenStatusMapMdl,
};

export default DoohMapReducer;
